export default __webpack_public_path__ + "static/media/car.342922f1.svg";